/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { RentalCars } from '../models';
// @ts-ignore
import { Vehicle } from '../models';
/**
 * VehicleApi - axios parameter creator
 * @export
 */
export const VehicleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all free RentalCars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarsFreeGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rentalcars/free`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all RentalCars
         * @param {number} [page] Pagenumber
         * @param {number} [perPage] Items shown per page
         * @param {string} [sort] Column to Sort example: license_plate, for desc -license_plate
         * @param {string} [filterCompany] 
         * @param {string} [filterLicensePlate] 
         * @param {string} [filterModel] 
         * @param {string} [filterManufacturer] 
         * @param {string} [filterWithTrashed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarsGet: async (page?: number, perPage?: number, sort?: string, filterCompany?: string, filterLicensePlate?: string, filterModel?: string, filterManufacturer?: string, filterWithTrashed?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rentalcars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterCompany !== undefined) {
                localVarQueryParameter['filter[company]'] = filterCompany;
            }

            if (filterLicensePlate !== undefined) {
                localVarQueryParameter['filter[license_plate]'] = filterLicensePlate;
            }

            if (filterModel !== undefined) {
                localVarQueryParameter['filter[model]'] = filterModel;
            }

            if (filterManufacturer !== undefined) {
                localVarQueryParameter['filter[manufacturer]'] = filterManufacturer;
            }

            if (filterWithTrashed !== undefined) {
                localVarQueryParameter['filter[withTrashed]'] = filterWithTrashed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the RentalCar by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarsIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rentalcarsIdDelete', 'id', id)
            const localVarPath = `/rentalcars/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a RentalCar
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarsIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rentalcarsIdGet', 'id', id)
            const localVarPath = `/rentalcars/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update RentalCar
         * @param {number} id 
         * @param {Vehicle} [vehicle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarsIdPut: async (id: number, vehicle?: Vehicle, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rentalcarsIdPut', 'id', id)
            const localVarPath = `/rentalcars/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicle, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Post RentalCar
         * @param {Vehicle} [vehicle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarsPost: async (vehicle?: Vehicle, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rentalcars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicle, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleApi - functional programming interface
 * @export
 */
export const VehicleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all free RentalCars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarsFreeGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RentalCars>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarsFreeGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all RentalCars
         * @param {number} [page] Pagenumber
         * @param {number} [perPage] Items shown per page
         * @param {string} [sort] Column to Sort example: license_plate, for desc -license_plate
         * @param {string} [filterCompany] 
         * @param {string} [filterLicensePlate] 
         * @param {string} [filterModel] 
         * @param {string} [filterManufacturer] 
         * @param {string} [filterWithTrashed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarsGet(page?: number, perPage?: number, sort?: string, filterCompany?: string, filterLicensePlate?: string, filterModel?: string, filterManufacturer?: string, filterWithTrashed?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RentalCars>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarsGet(page, perPage, sort, filterCompany, filterLicensePlate, filterModel, filterManufacturer, filterWithTrashed, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete the RentalCar by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarsIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a RentalCar
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarsIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Vehicle>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update RentalCar
         * @param {number} id 
         * @param {Vehicle} [vehicle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarsIdPut(id: number, vehicle?: Vehicle, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Vehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarsIdPut(id, vehicle, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Post RentalCar
         * @param {Vehicle} [vehicle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarsPost(vehicle?: Vehicle, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Vehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarsPost(vehicle, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VehicleApi - factory interface
 * @export
 */
export const VehicleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleApiFp(configuration)
    return {
        /**
         * Get all free RentalCars
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarsFreeGet(options?: any): AxiosPromise<Array<RentalCars>> {
            return localVarFp.rentalcarsFreeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all RentalCars
         * @param {number} [page] Pagenumber
         * @param {number} [perPage] Items shown per page
         * @param {string} [sort] Column to Sort example: license_plate, for desc -license_plate
         * @param {string} [filterCompany] 
         * @param {string} [filterLicensePlate] 
         * @param {string} [filterModel] 
         * @param {string} [filterManufacturer] 
         * @param {string} [filterWithTrashed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarsGet(page?: number, perPage?: number, sort?: string, filterCompany?: string, filterLicensePlate?: string, filterModel?: string, filterManufacturer?: string, filterWithTrashed?: string, options?: any): AxiosPromise<Array<RentalCars>> {
            return localVarFp.rentalcarsGet(page, perPage, sort, filterCompany, filterLicensePlate, filterModel, filterManufacturer, filterWithTrashed, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the RentalCar by ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarsIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.rentalcarsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a RentalCar
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarsIdGet(id: number, options?: any): AxiosPromise<Array<Vehicle>> {
            return localVarFp.rentalcarsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update RentalCar
         * @param {number} id 
         * @param {Vehicle} [vehicle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarsIdPut(id: number, vehicle?: Vehicle, options?: any): AxiosPromise<Vehicle> {
            return localVarFp.rentalcarsIdPut(id, vehicle, options).then((request) => request(axios, basePath));
        },
        /**
         * Post RentalCar
         * @param {Vehicle} [vehicle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarsPost(vehicle?: Vehicle, options?: any): AxiosPromise<Vehicle> {
            return localVarFp.rentalcarsPost(vehicle, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehicleApi - object-oriented interface
 * @export
 * @class VehicleApi
 * @extends {BaseAPI}
 */
export class VehicleApi extends BaseAPI {
    /**
     * Get all free RentalCars
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public rentalcarsFreeGet(options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).rentalcarsFreeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all RentalCars
     * @param {number} [page] Pagenumber
     * @param {number} [perPage] Items shown per page
     * @param {string} [sort] Column to Sort example: license_plate, for desc -license_plate
     * @param {string} [filterCompany] 
     * @param {string} [filterLicensePlate] 
     * @param {string} [filterModel] 
     * @param {string} [filterManufacturer] 
     * @param {string} [filterWithTrashed] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public rentalcarsGet(page?: number, perPage?: number, sort?: string, filterCompany?: string, filterLicensePlate?: string, filterModel?: string, filterManufacturer?: string, filterWithTrashed?: string, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).rentalcarsGet(page, perPage, sort, filterCompany, filterLicensePlate, filterModel, filterManufacturer, filterWithTrashed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the RentalCar by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public rentalcarsIdDelete(id: number, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).rentalcarsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a RentalCar
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public rentalcarsIdGet(id: number, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).rentalcarsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update RentalCar
     * @param {number} id 
     * @param {Vehicle} [vehicle] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public rentalcarsIdPut(id: number, vehicle?: Vehicle, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).rentalcarsIdPut(id, vehicle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Post RentalCar
     * @param {Vehicle} [vehicle] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public rentalcarsPost(vehicle?: Vehicle, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).rentalcarsPost(vehicle, options).then((request) => request(this.axios, this.basePath));
    }
}
